import type { ProductCard as ProductCardType } from "@raumagarn/formatters";
import { clsx } from "@trydig/ui";
import { Card as ArticleCard, isArticleCard } from "~/components/bloks/ArticleCardBlok";
import { Tab, Tabs, Trigger } from "~/components/ui/Tabs/Tabs";
import { Slider } from "~/components/ui/TabsUI/Slider";
import { ProductCard } from "~/features/products/ProductCard/ProductCard";
import type { fetchTabs } from "~/lib/storyblok/storyblokServerFunctions";
import type { BlokData } from "~/srpc/routes/story.router";
import styles from "./TabsUI.module.css";

export const TabsUI = ({
	title,
	tabsData,
	cardType = "product",
	preview,
}: {
	title?: string;
	tabsData?: BlokData["articleListing"] | Awaited<ReturnType<typeof fetchTabs>>;
	cardType?: "article" | "product";
	preview: boolean;
}) => {
	const tabs = tabsData;
	const isSingleTab = tabsData?.length === 1;

	if (tabs?.every((tab) => !tab.cards?.length)) return null; // all empty

	return (
		<div className={styles.root} data-layout="blok" data-mobile-bleed="true">
			{title && (
				<h2
					className={clsx("blok-title", styles.title__spacing, isSingleTab && styles.single__tab)}
				>
					{title}
				</h2>
			)}
			{tabs && (
				<Tabs tabIds={tabs?.map((tab) => tab._uid)}>
					{!isSingleTab && (
						<div className={styles.tags}>
							{tabs?.map((tab, i) => (
								<Trigger tabId={tab._uid} key={`${tab._uid}trigger${i}`}>
									<button className="transparent" type="button">
										{tab.name}
									</button>
								</Trigger>
							))}
						</div>
					)}
					{tabs?.map((tab, i) => (
						<Tab tabId={tab._uid} key={`${tab._uid}tab${i}`}>
							<Slider uuid={tab._uid}>
								{tab?.cards?.map((card, i) => (
									<div
										className={clsx(styles.slide, cardType === "article" && styles.article__slide)}
										key={`card-${tab._uid}-${i}`}
									>
										{cardType === "product" ? (
											<ProductCard productCard={card as ProductCardType} />
										) : (
											isArticleCard(card) && (
												<ArticleCard article={card} slideshow preview={preview} />
											)
										)}
									</div>
								))}
							</Slider>
						</Tab>
					))}
				</Tabs>
			)}
		</div>
	);
};
